<template>
  <div class="noprint">
    <AdminHeader></AdminHeader>
    <section class="admin-back">
      <div>
        <i class="fa fa-angle-left"></i>
        <router-link to="/admin/orderList">返回訂單總覽</router-link>
      </div>
    </section>
    <section class="edit-goldFee-container">
      <div class="goldFee-header-container">
        <div class="goldFee-title">工錢修改</div>
        <div class="goldFee-status">
          <div class="goldFee active goldFeeStatus" v-on:click="refreshgoldFee('A',$event)">A 精緻平裝純金金牌</div>
          <div class="goldFee goldFeeStatus" v-on:click="refreshgoldFee('B',$event)">B 立體浮雕純金金牌</div>
          <div class="goldFee goldFeeStatus" v-on:click="refreshgoldFee('C',$event)">C 立體浮雕鐳射紅字純金金牌</div>
          <div class="goldFee goldFeeStatus" v-on:click="refreshgoldFee('D',$event)">D 週歲鎖片</div>
          <div class="goldFee goldFeeStatus" v-on:click="refreshgoldFee('E',$event)">E 純金獎牌</div>
          <div class="goldFee goldFeeStatus" v-on:click="refreshgoldFee('F',$event)">F 雙面法扇</div>
          <div class="goldFee goldFeeStatus" v-on:click="refreshgoldFee('G',$event)">G 單面法扇</div>
          <div class="goldFee goldFeeStatus" v-on:click="refreshgoldFee('H',$event)">H 傳統金牌雷雕字體</div>
        </div>
      </div>
      <div class="load" v-if="!feeData">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <div class="list-container" v-else>
        <div class="list-title">
          <div class="weight-title">
            <span>重量</span>
          </div>
          <div class="cm-title">
            <span>公分</span>
          </div>
          <div class="inch-title">
            <span>台寸</span>
          </div>
          <div class="price-title">
            <span>工錢(一般)</span>
          </div>
          <div class="price-title">
            <span>工錢(同業)</span>
          </div>
          <div class="price-title">
            <span>工錢(成本)</span>
          </div>
        </div>
        <div class="list-item" v-for="fee in feeData" :key="fee.id">
          <div class="weight-title">
            <span>{{fee.min_weight}}-{{fee.max_weight}}</span>
          </div>
          <div class="cm-title">
            <span>{{fee.cm_length}}</span>
          </div>
          <div class="inch-title">
            <span>{{fee.tin_length}}</span>
          </div>
          <div class="price-title">
            <input v-model.number="fee.fee">
          </div>
          <div class="price-title">
            <input v-model.number="fee.peer_fee">
          </div>
          <div class="price-title">
            <input v-model.number="fee.cost">
          </div>
        </div>
        <div class="btn-container">
          <button @click="updateFee">儲存變更</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/admin_header.vue";
import axios from "axios";

export default {
  name: "admin_edit_goldFee",
  components: {
    AdminHeader
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isSave) {
      let userResponse = confirm("您的資料尚未儲存，確定離開嗎？");
      if (userResponse) {
        next();
      }
    } else {
      next();
    }
  },
  created() {
    this.getFeeData("A");
  },
  data() {
    return {
      feeData: "",
      isSave: true,
      nowWay: "A"
    };
  },
  watch: {
    feeData: {
      handler() {
        this.isSave = false;
      },
      deep: true
    }
  },
  methods: {
    getFeeData(way) {
      axios({
        url: this.$store.getters.getGlobalUrl + "admin/fees?way=" + way,
        method: "get"
      })
        .then(response => {
          this.feeData = response.data.data;
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    refreshgoldFee(way, e) {
      //css樣式調整
      let allgoldFeeStatus = document.querySelectorAll(".goldFeeStatus");
      allgoldFeeStatus.forEach(item => {
        item.classList.remove("active");
      });
      e.target.classList.add("active");
      this.feeData = "";
      this.getFeeData(way);
      this.nowWay = way;
    },
    updateFee() {
      this.isSave = true;
      let feeUpdateData = [];
      this.feeData.forEach(item => {
        feeUpdateData.push({
          id: item.id,
          fee: item.fee,
          peer_fee: item.peer_fee,
          cost: item.cost
        });
      });
      axios({
        url: this.$store.getters.getGlobalUrl + "admin/fees",
        method: "patch",
        data: feeUpdateData
      })
        .then(() => {
          alert("更新資料成功");
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    }
  }
};
</script>

<style scoped lang="scss">
* {
  font-size: 17px;
  box-sizing: border-box;
  color: $secondaryDeepColor1;
}
.admin-back {
  display: flex;
  align-items: center;
  height: 66px;
  margin: 0 30px;
  i {
    color: $secondaryDeepColor1;
    margin-right: 10px;
  }
  a {
    color: $secondaryDeepColor1;
  }
}
.goldFee-header-container {
  background-color: #f7f7f8;
  padding-top: 10px;
  .goldFee-title {
    font-size: 20px;
    font-weight: 500;
    padding: 10px 0;
    padding-left: 30px;
  }
}
.goldFee-status {
  display: flex;
  color: $secondaryLightColor1;
  border-bottom: 1px solid #ddd;
  .goldFee {
    display: inline;
    cursor: pointer;
    padding: 10px 30px;
  }
  .active {
    color: $secondaryDeepColor1;
    font-weight: 500;
    border-bottom: 3px $secondaryDeepColor1 solid;
  }
}
.list-container {
  padding: 15px 5px;
}
.list-title,
.list-item {
  width: 65%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  align-items: center;
  text-align: center;
}
.list-title {
  padding: 30px 0;
}
.list-item {
  padding: 10px 0;
  input {
    width: 85%;
    padding: 6px;
    text-align: right;
  }
}
.btn-container {
  width: 65%;
  text-align: right;
  padding-right: 1%;
  button {
    width: 120px;
    height: 35px;
    border-radius: 2px;
    padding: 0;
    background-color: #4a90e2;
    color: #fff;
    &:hover {
      background-color: darken(#4a90e2, 10%);
    }
  }
}
//loading
.load {
  display: flex;
  justify-content: center;
  align-items: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #2275d7;
}
@keyframes loadingC {
  0 {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
